/**
 * 编辑车辆诊断车辆状态
 */
import React, {useState, useEffect} from "react";
import {Modal, Form, message, Input, Checkbox, Radio} from "antd";
import {updateVehicleStateRequest} from "@/service/carManage";

interface AssignModalProps {
  data: any; // 工单信息
  type?: string; // 操作类型(指派/重新指派)
  onClose: () => void; // 关闭弹窗的方法
  onOk?: () => void; // 确认操作的方法
}

const EditVehicleStateModal = (props: AssignModalProps) => {
  const {data, onClose,onOk} = props;
  const [loading, setLoading] = useState<boolean>(false); // 提交接口是否请求中
  const [form] = Form.useForm();
  const [submitNoRepetition, setSubmitNoRepetition] = useState(true); // 不能重复请求
  const [changeVehicleState, setChangeVehicleState] = useState<any>();
  const [carId, setCarId] = useState<any>(null);

  useEffect(() => {
    const oldValue = {
      vehicleState: data.vehicleState,
    };
    form.setFieldsValue(oldValue);
  }, []);

  // 编辑请求
  const submit = async (values: any) => {
    if (submitNoRepetition) {
      setSubmitNoRepetition(false);
      try {
        const params: any = {};
        params.id = data.carId;
        params.vehicleState = changeVehicleState;
        const res = await updateVehicleStateRequest(params);
        setLoading(true);
        if (res.status == 200) {
          setSubmitNoRepetition(true);
        }
        setLoading(false);
        if (res.data?.code === 0) {
          message.success("修改成功");
          onClose();
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const onChange = (e: any) => {
    setChangeVehicleState(e.target.value);
  }

  return (
    <Modal
      title={"编辑车辆状态"}
      visible
      centered
      onCancel={onClose}
      onOk={() => {
        form.submit()
        onOk && onOk()
      }}
      okButtonProps={{loading}}
      maskClosable={false}
      width={580}
    >
      <Form
        form={form}
        autoComplete="off"
        layout="vertical"
        scrollToFirstError
        onFinish={submit}
      >
        <Form.Item name="vehicleState" label="车辆状态">
          <Radio.Group style={{width: '100%'}} onChange={onChange}>
            <Radio value={'正常'}>正常</Radio>
            <Radio value={'停用'}>停用</Radio>
            <Radio value={'故障'}>故障</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditVehicleStateModal;
